import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PaginatePipeArgs } from 'ngx-pagination';
import { InstrumentDetailFullOut } from 'src/app/services/rest-api/rest-api';
import { AvailablePerformanceYears } from '../listable-instruments/listable-instruments.component';

@Component({
  selector: 'libero-listable-instruments-table',
  templateUrl: './available-listable-instruments.component.html',
  styleUrls: ['./available-listable-instruments.component.scss'],
  standalone: false
})

export class ListableInstrumentsTableComponent implements OnChanges {
  @Input() public availableInstruments?: InstrumentDetailFullOut[];
  @Input() public selectedPerformance!: AvailablePerformanceYears;
  @Input() public refreshPagination?: boolean;
  @Input() public hideAddButtons = false;

  public paginationConfig: PaginatePipeArgs = {
    itemsPerPage: 10,
    currentPage: 1,
    id: 'available-instruments-pagination'
  };

  public ngOnChanges(changes: SimpleChanges): void {
    if(changes['availableInstruments'] || changes['refreshPagination']) {
      this.paginationConfig.currentPage = 1;
    }
  }
}
